const _cf = new URLSearchParams(window.location.search).get('_cf');
let useCF = _cf === '1' || _cf === 'true';
if (_cf === null) {
    useCF =
        process.env.cdn === undefined ||
        process.env.cdn === '1' ||
        process.env.cdn === 1 ||
        process.env.cdn === 'true' ||
        process.env.cdn === true;
}

// Cloudflare isn't used by default anymore
module.exports = {
    apiServerUrl: useCF ? 'https://api.amplement.io' : 'https://api.amplement.com',
    publicHostname: 'https://www.amplement.com',
    websocketHostname: useCF ? 'https://ws.amplement.io' : 'https://ws.amplement.com',
    debug: false,
    logLevel: 'warn'
};
